import { render, staticRenderFns } from "./entrepotList.vue?vue&type=template&id=108a54ce&scoped=true&"
import script from "./entrepotList.vue?vue&type=script&lang=js&"
export * from "./entrepotList.vue?vue&type=script&lang=js&"
import style0 from "./entrepotList.vue?vue&type=style&index=0&id=108a54ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a54ce",
  null
  
)

export default component.exports